import { BuiltInPlan } from "../../lib/workout";

export default {
  id: "c03adcfc-d1c8-4c55-a4f6-641407c68aec",
  title: "New (km)",
  raceType: "Template",
  units: "kilometers",
  workouts: [
    {
      description: "Easy 5 kilometers",
      totalDistance: 5,
    },
  ],
} as BuiltInPlan;
